const apiUrls = require('../../constants/apiUrls');

const networkDetails = {
    key: 'networkDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.NETWORK_DETAIL_URL}/${request.customerId}/${request.billingSystem}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'customerInfo', 'customerId'
                    ],
                    propName: 'customerId'
                }, {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }
    ]
};

export default networkDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/networkDetails.js